/**
 * Scrolling Banner
 *
 * @author BarrelNY
 * @since 35.7.0
 */

import axios from 'axios'
import InfiniteMarquee from "infinite-marquee"

export default function(el) {
  const duration = el.dataset.duration || 30
  const container = el.querySelector(".marquee-content")
  let posts = []

  axios.get('/wp-json/wellandgood/v1/instagram/feed').then(response => {
    if (Array.isArray(response.data) && response.data.length > 0 ) {
      posts = response.data.slice(0, 6)
    }
  })

  new InfiniteMarquee({
    el,
    duration,
    css: false
  })
}
